<template>
<margin-title :title="title" :subtitle="tokens" :extension="extension">
  <span class="extension" v-if="extension"> {{ extension }}</span>
</margin-title>
</template>

<script>
import MarginTitle from './margin-title'
import {mapGetters} from 'vuex'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('wallet', ['getActiveToken']),
    tokens () {
      let decimalPlaces = 2
      if (this.amount < 1) {
        decimalPlaces = 4
      }
      return `VIBES ${this.amount.toLocaleString(undefined, {minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces})}`
    },
    extension () {
      // Todo:: fetch updated price from coingeco exchange api
      return `/ USD ${(this.amount * 0.00249629).toFixed(2)}`
    }
  },
  components: { MarginTitle }
}
</script>

<style lang="scss" scoped>
.margin {
  & > h1 {
    font-weight: 700;
    &.subtitle {
      color: black;
    }
  }
}
.title.is-margin-header {
  color: #c7c7c7;
}

span.extension {
  color: #c7c7c7;
  font-size: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/hvt-margin-title.vue